import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SearchTabs } from "@/components/SearchTabs";
import { BookOpen, Database } from "lucide-react";
import { usePageVisit } from "@/hooks/usePageVisit";

const Index = () => {
  usePageVisit('/');
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />

      <main className="flex-1 flex flex-col items-center px-4 py-6 sm:py-10">
        {/* Search Section - Main focus */}
        <div className="w-full max-w-5xl mx-auto">
          <div className="bg-card rounded-2xl border border-border/60 shadow-card p-6 sm:p-8">
            <div className="text-center mb-6">
              <h1 className="font-display text-2xl sm:text-3xl font-medium text-foreground mb-2">Korsordslexikon</h1>
              <p className="text-sm text-muted-foreground">Skriv in bokstäverna du känner till – vi hittar resten</p>
            </div>

            <SearchTabs />
          </div>
        </div>

        {/* Info Section */}
        <div className="mt-10 max-w-3xl mx-auto w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InfoCard
              icon={<BookOpen className="w-5 h-5" />}
              title="Enkel sökning"
              description="Fyll i de bokstäver du vet och lämna resten tomt. Välj ordlängd om du vet den."
            />
            <InfoCard
              icon={<Database className="w-5 h-5" />}
              title="Stor databas"
              description="Vi har samlat tusentals svenska ord och korsordslösningar genom åren."
            />
          </div>
        </div>

        {/* Personal touch */}
        <div className="mt-12 text-center max-w-lg mx-auto">
          <p className="text-sm text-muted-foreground leading-relaxed">
            Korsordslexikon.se har hjälpt svenska korsordslösare sedan 2004. Har du förslag på förbättringar? Hör av dig
            i vårt{" "}
            <a href="/?tab=forum" className="text-primary hover:underline">
              forum
            </a>
            .
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

interface InfoCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const InfoCard = ({ icon, title, description }: InfoCardProps) => (
  <div className="p-4 rounded-xl bg-secondary/40 border border-border/40">
    <div className="flex items-center gap-2 mb-2 text-primary">
      {icon}
      <h3 className="font-display font-medium text-foreground">{title}</h3>
    </div>
    <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
  </div>
);

export default Index;
